// ==============================
// WEBSITE IMAGES
// ==============================
import website1 from '../../src/assets/Portfolio/portfolio-website1.webp'
import website2 from '../../src/assets/Portfolio/portfolio-website2.webp'
import website3 from '../../src/assets/Portfolio/portfolio-website3-1.webp'
import website4 from '../../src/assets/Portfolio/portfolio-website4.webp'
import website5 from '../../src/assets/Portfolio/portfolio-website5.webp'
import website6 from '../../src/assets/Portfolio/portfolio-website6.webp'
import website7 from '../../src/assets/Portfolio/portfolio-website7.webp'
import website8 from '../../src/assets/Portfolio/portfolio-website8.webp'
import website9 from '../../src/assets/Portfolio/portfolio-website9.webp'
import website10 from '../../src/assets/Portfolio/portfolio-website10.webp'
import website11 from '../../src/assets/Portfolio/portfolio-website11.webp'
import website12 from '../../src/assets/Portfolio/portfolio-website12.webp'
import website13 from '../../src/assets/Portfolio/portfolio-website13.webp'
import website14 from '../../src/assets/Portfolio/sridhar-portfolio.webp'
import website15 from '../../src/assets/Portfolio/portfolio-website15.webp'
import website16 from '../../src/assets/Portfolio/portfolio-website16.webp'


// ==============================
// MOBILE IMAGES
// ==============================
import mobile1 from '../../src/assets/Portfolio/portfolio-mobile1.webp'
import mobile2 from '../../src/assets/Portfolio/portfolio-mobile2.webp'
import mobile3 from '../../src/assets/Portfolio/portfolio-mobile3-1.webp'
import mobile4 from '../../src/assets/Portfolio/portfolio-mobile4-1.webp'
import mobile5 from '../../src/assets/Portfolio/portfolio-mobile5.webp'
import mobile6 from '../../src/assets/Portfolio/portfolio-mobile6.webp'
import mobile7 from '../../src/assets/Portfolio/portfolio-mobile7.webp'
import mobile8 from '../../src/assets/Portfolio/portfolio-mobile8.webp'

// ==============================
// SOFTWARE IMAGES
// ==============================
import software1 from '../../src/assets/Portfolio/portfolio-software1.webp'
import software2 from '../../src/assets/Portfolio/portfolio-software2.webp'
import software3 from '../../src/assets/Portfolio/portfolio-software3.webp'
import software4 from '../../src/assets/Portfolio/portfolio-software4-1.webp'
import software5 from '../../src/assets/Portfolio/portfolio-software5.webp'
import software6 from '../../src/assets/Portfolio/portfolio-software6.webp'
import software7 from '../../src/assets/Portfolio/portfolio-website17.webp'
// ==============================
// UI/UX IMAGES
// ==============================
import uiux1 from '../../src/assets/Portfolio/ui-design.webp'
import uiux2 from '../../src/assets/Portfolio/ux-flow.webp'
import uiux3 from '../../src/assets/Portfolio/prototype.webp'
import uiux4 from '../../src/assets/Portfolio/mobile-ui.webp'
import uiux5 from '../../src/assets/Portfolio/design-system.webp'
import uiux6 from '../../src/assets/Portfolio/wireframe.webp'

// ==============================
// DIGITAL MARKETING IMAGES
// ==============================
import dm1 from '../../src/assets/Portfolio/portfolio-dm1.webp'
import dm2 from '../../src/assets/Portfolio/portfolio-dm2.webp'
import dm3 from '../../src/assets/Portfolio/portfolio-dm3.webp'
import dm4 from '../../src/assets/Portfolio/portfolio-dm4.webp'
import dm5 from '../../src/assets/Portfolio/portfolio-dm5.webp'

import filedforce from '../../src/assets/Portfolio/FILEDFORCE.png'
import ahamart from '../../src/assets/Portfolio/AHAMART.png'
// ==============================
// PROJECT DATA
// ==============================

const projectData = {
  website: [
    { title: "Sanjay Ghodawat University", image: website3, url: "https://www.sanjayghodawat.co.in/" },
    { title: "GH Raisoni, Saikheda", image: website15, url: "https://ghraisoni.com/" },
    { title: "JOY UNIVERSITY", image: website4, url: "https://joyuniversity.edu.in/" },
    { title: "SANDIP UNIVERSITY", image: website5, url: "https://www.sandipuniversity.edu.in/" },
    { title: "RAYUDU GARI MILITARY HOTEL", image: website6, url: "https://rgmhotel.com/" },
    { title: "ORION TECHNICAL COLLEGE", image: website7, url: "https://orion.edu/" },
    { title: "CYIENT", image: website8, url: "https://www.cyient.com/geospatial/earth-observation" },
    { title: "CYCLOMEDIA", image: website9, url: "https://www.cyclomedia.com/en/products/data-insights/geo-objects" },
    { title: "UNIHARBOUR", image: website10, url: "https://www.uniharbour.com/" },
    { title: "SRI JYOTHI POLYTECHNIC", image: website2, url: "https://srijyothipolytechnic.com/" },
    { title: "ASIAN CROP CARE", image: website16, url: "https://asiancropcare.co/" },
    { title: "SRI ANJANEYA RESTAURANTS", image: website11 },
    { title: "GSR FARMS AND FOODS", image: website12 },
    { title: "SKII ARTS", image: website1 },
    { title: "PENTIP", image: website13 },
    { title: "SBID", image: website14 },
      
  ],

  mobile: [
    { title: "Dhan Shakti", image: mobile1 },
    { title: "High Ghar", image: mobile2 },
    { title: "Oakya Ecom App", image: mobile3 },
    { title: "Oakya Home Services", image: mobile4 },
    { title: "Mech Guru", image: mobile5 },
    { title: "School App", image: mobile6 },
    { title: "Campus Connect", image: mobile7 },
    { title: "Gait View", image: mobile8 },
            { title: "FILED FORCE", image: filedforce },
    { title: "AHA MART", image: ahamart }
  ],

  software: [
    { title: "GH Raisoni", image: software1 },
    { title: "Dhan Shakti Admin", image: software2 },
    { title: "School ERP", image: software6 },
    { title: "Mech Guru", image: software7 },
    { title: "Indrashil University (bipc)", image: software3 },
    { title: "Sanjay Ghodawat University", image: software4 },
    { title: "High Ghar", image: software5 },

  ],

  uiux: [
    { title: "Wireframe", image: uiux6 },
    { title: "UI Design", image: uiux1 },
    { title: "UX Flow", image: uiux2 },
    { title: "Prototyping Tool", image: uiux3 },
    { title: "Mobile UI", image: uiux4 },
    { title: "Design System", image: uiux5 }
  ],

  marketing: [
    { title: "SEO Optimization", image: dm1 },
    { title: "Social Campaign", image: dm2 },
    { title: "Email Marketing", image: dm3 },
    { title: "PPC Advertising", image: dm4 },
    { title: "Content Marketing", image: dm5 }
  ],
  ecommerce: [
    { title: "Oakya Ecom App", image: mobile3 },
    { title: "Oakya Home Services", image: mobile4 },
    { title: "High Ghar", image: mobile2 },
  ]
};
export default projectData;